import { render, staticRenderFns } from "./VolunteerStatistics.vue?vue&type=template&id=171e80e8"
import script from "./VolunteerStatistics.vue?vue&type=script&lang=js"
export * from "./VolunteerStatistics.vue?vue&type=script&lang=js"
import style0 from "./VolunteerStatistics.vue?vue&type=style&index=0&id=171e80e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports